module.exports = __webpack_public_path__ + "65e669d8070a105fcadf1f79f1ff58fc.pdf";